import { render, staticRenderFns } from "./myinfo.vue?vue&type=template&id=fead32a4&scoped=true"
import script from "./myinfo.vue?vue&type=script&lang=js"
export * from "./myinfo.vue?vue&type=script&lang=js"
import style0 from "./myinfo.vue?vue&type=style&index=0&id=fead32a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead32a4",
  null
  
)

export default component.exports